// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/transponder-equipment.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/transponder-equipment/transponder-equipment.js';

mount([g0]);
